export default {
	title: 'Portfólio',
	description: 'Todos os meus projetos Gerositus',
	actions: {
		back_to_this: 'Voltar ao portfólio'
	},
	search_projects: 'Pesquisar projetos',
	cta: {
		welcome:
			'Bem-vindo e obrigado por usar o Gerositus Strategy Suite!',
		subscribe: 'Assine agora',
		create_permission: 'para poder criar novos projetos.'
	},
	tabs: {
		risks: {
			title: 'Parâmetros de riscos e oportunidades'
		}
	}
};
